import { ItAssetDetailsDocument, ItAssetDetailsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useAssetDetails = (
  assetId: string | undefined
): {
  asset: ItAssetDetailsQuery['itManagement']['itAsset'] | null
  loading: boolean
  error: string | null
  refreshAsset: () => Promise<void>
} => {
  const { data, loading, error, refetch } = useQuery(ItAssetDetailsDocument, {
    variables: { id: assetId || '' },
    skip: !assetId,
    extra: {
      errorFlash: false, // Disable automatic error flash since we handle errors in the component
    },
  })

  return {
    asset: data?.itManagement?.itAsset || null,
    loading,
    error: error?.message || null,
    refreshAsset: async () => {
      await refetch()
    },
  }
}
